import { render, staticRenderFns } from "./IdeaPlanQuickTour.vue?vue&type=template&id=888d3012"
import script from "./IdeaPlanQuickTour.vue?vue&type=script&lang=js"
export * from "./IdeaPlanQuickTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports